let cloudinaryMappingFolder
const getCloudinaryMappingFolder = () => cloudinaryMappingFolder ||=
  document.querySelector('meta[name="cloudinary-mapping-folder"]')
  .getAttribute('content')

let cloudinaryOrigin
const getCloudinaryOrigin = () => cloudinaryOrigin ||=
  document.querySelector('meta[name="cloudinary-origin"]')
  .getAttribute('content')

const utf8Encoder = new TextEncoder()

const smartEscape = (string, unsafe = /([^a-zA-Z0-9_.\-\/:]+)/g) =>
  string.replace(unsafe, match =>
    Array.from(utf8Encoder.encode(match))
      .map(b => '%' + b.toString(16).toUpperCase().padStart(2, '0'))
      .join('')
  )

const mapKey = key => ({ border: 'bo' })[key] || key[0]

// Mirrors cloudinary_image_path's accepted_formats (application_helper.rb).
// Browsers can't decode anything else — notably the HEIC iOS uploads — so
// have Cloudinary transcode it.
const ACCEPTED_FORMATS = [ '.jpg', '.jpeg', '.png', '.gif', '.svg' ]

const cloudinaryUrl = (source, options={}, {
  origin=getCloudinaryOrigin(),
  mappingFolder=getCloudinaryMappingFolder(),
}={}) => {
  // Callers share transform constants (COVER_TRANSFORM et al), so don't
  // mutate — the deletes below would strip them for every later caller.
  options = { ...options }

  // Equivalent to Ruby's File.extname(source).downcase.
  const fileExt = (/.\.[^./]*$/.exec(source.slice(source.lastIndexOf('/') + 1))
    || [ '' ])[0].slice(1).toLowerCase()
  if (!ACCEPTED_FORMATS.includes(fileExt))
    options.fetchFormat ||= 'png' // ||= so an explicit fetchFormat wins

  // Staying vector: raster transforms don't apply, and neither does the
  // format. 'auto' counts — cloudinary_image_path lists it alongside ''/'svg'.
  if (
    fileExt == '.svg' &&
    [ '', 'svg', 'auto' ].includes((options.fetchFormat || '').toLowerCase())
  ) {
    delete options.width
    delete options.height
    delete options.crop
    delete options.fetchFormat
  }

  const params = Object.keys(options).map(key =>
    smartEscape([ mapKey(key), options[key] ].join('_'))
  ).join()

  return [
    origin,
    params,
    mappingFolder,
    smartEscape(source.replace(/^media\//, '')),
  ].filter(Boolean).join('/')
}

export default cloudinaryUrl
